import React from 'react'
import { Typography } from '@mui/material'

const UiTextBodyMedium = ({ text, children, sx, ...props }) => {
  return (
    <Typography
      sx={{
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: 'normal',
        letterSpacing: '0.25px',
        ...sx,
      }}
      {...props}
    >
      {text || children}
    </Typography>
  )
}

export default UiTextBodyMedium
